import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 海康威视专用的api
 **********************************************************************************/
export default {
	/**
	 * 获取海康威视摄像头ID对应的预览地址
	 */
	getCameraUrlById: (cameraId,success, failure) => {
		Axios.post('/hikvison/getCameraUrlById.do', {cameraId}, success, failure);
	},
}
